var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my--order-header"},[_c('div',{staticClass:"dashboard--search-container"},[_c('search-order')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }